import { EventEmitter } from "pixi.js";


export enum EnumCursorEventBus {
  setCursor = "SET_CURSOR",
  setRotation = "SET_ROTATION",
  setColor = "SET_COLOR",
  setInteractLayerCursor = "SET_INTERACTIVITY_LAYER_CUSTOM_CURSOR"
}


export const cursorEventBus = new EventEmitter();